// extracted by mini-css-extract-plugin
export var formCloseButton = "component-module--formCloseButton--187f2";
export var formContainer = "component-module--formContainer--bb9b3";